"use client"

import React, { useEffect, useState } from "react"
import Image from "next/image"
import { useTheme } from "next-themes"
import DarkToggler from "@/assets/images/dark-mode-button.png"
import LightToggler from "@/assets/images/light-mode-button.png"

const DarkMode = () => {
  const { theme, setTheme, resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  // Ensure we only render client-side
  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return <div className="w-12 h-12" aria-hidden="true" />
  }

  // Determine which image to show based on ACTIVE theme (resolvedTheme)
  const currentTheme = resolvedTheme || theme
  const toggleImage = currentTheme === "dark" ? DarkToggler : LightToggler
  const altText = `Switch to ${currentTheme === "dark" ? "light" : "dark"} mode`

  return (
    <button
      className="z-10 w-12 h-12 cursor-pointer transition-all duration-300 focus:outline-none"
      onClick={() => setTheme(currentTheme === "dark" ? "light" : "dark")}
      aria-label={altText}
    >
      <Image
        src={toggleImage}
        alt={altText}
        width={48}
        height={48}
        className="w-full h-auto"
        priority
      />
    </button>
  )
}

export default DarkMode